<a class="chatbox-btn toggle-chatbox-button fa fa-minus" title="{{{o.info_minimize}}}"></a>
